import FormattedMessage from 'I18n/components/FormattedMessage';
import ExecutionEventTable from 'automation-ui-log-events/components/execution-results/components/ExecutionEventTable';
import ExecutionResultsLoading from 'automation-ui-log-events/components/execution-results/components/ExecutionResultsLoading';
import ExecutionResultsError from 'automation-ui-log-events/components/execution-results/components/ExecutionResultsError';
import { jsx as _jsx } from "react/jsx-runtime";
const SuccessfulExecutionResults = ({
  actionType,
  error,
  executionResults,
  flowObjectTypeId,
  loading
}) => {
  if (loading) {
    return /*#__PURE__*/_jsx(ExecutionResultsLoading, {});
  }
  if (error) {
    return /*#__PURE__*/_jsx(ExecutionResultsError, {});
  }
  const hasSuccessfulResults = executionResults.length > 0;
  const titleContent = hasSuccessfulResults ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-log-events.logEventExecutionResultsTable.successTable"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-log-events.logEventExecutionResultsTable.allFailure"
  });
  return /*#__PURE__*/_jsx(ExecutionEventTable, {
    titleContent: titleContent,
    executionResults: executionResults,
    flowObjectTypeId: flowObjectTypeId,
    actionType: actionType
  });
};
export default SuccessfulExecutionResults;